/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Toast_RejectedInputs */

const en_keyword_optimizer_toast_rejected = /** @type {(inputs: Keyword_Optimizer_Toast_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestion dismissed`)
};

const de_keyword_optimizer_toast_rejected = /** @type {(inputs: Keyword_Optimizer_Toast_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschlag abgelehnt`)
};

const fr_keyword_optimizer_toast_rejected = /** @type {(inputs: Keyword_Optimizer_Toast_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestion ignorée`)
};

const es_keyword_optimizer_toast_rejected = /** @type {(inputs: Keyword_Optimizer_Toast_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerencia descartada`)
};

const it_keyword_optimizer_toast_rejected = /** @type {(inputs: Keyword_Optimizer_Toast_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggerimento ignorato`)
};

const nl_keyword_optimizer_toast_rejected = /** @type {(inputs: Keyword_Optimizer_Toast_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestie afgewezen`)
};

const pl_keyword_optimizer_toast_rejected = /** @type {(inputs: Keyword_Optimizer_Toast_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugestia odrzucona`)
};

const fi_keyword_optimizer_toast_rejected = /** @type {(inputs: Keyword_Optimizer_Toast_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ehdotus ohitettu`)
};

const da_keyword_optimizer_toast_rejected = /** @type {(inputs: Keyword_Optimizer_Toast_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forslag afvist`)
};

const sv_keyword_optimizer_toast_rejected = /** @type {(inputs: Keyword_Optimizer_Toast_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förslag avvisat`)
};

/**
* | output |
* | --- |
* | "Suggestion dismissed" |
*
* @param {Keyword_Optimizer_Toast_RejectedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_toast_rejected = /** @type {((inputs?: Keyword_Optimizer_Toast_RejectedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Toast_RejectedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_toast_rejected(inputs)
	if (locale === "fr") return fr_keyword_optimizer_toast_rejected(inputs)
	if (locale === "es") return es_keyword_optimizer_toast_rejected(inputs)
	if (locale === "it") return it_keyword_optimizer_toast_rejected(inputs)
	if (locale === "nl") return nl_keyword_optimizer_toast_rejected(inputs)
	if (locale === "pl") return pl_keyword_optimizer_toast_rejected(inputs)
	if (locale === "fi") return fi_keyword_optimizer_toast_rejected(inputs)
	if (locale === "da") return da_keyword_optimizer_toast_rejected(inputs)
	if (locale === "sv") return sv_keyword_optimizer_toast_rejected(inputs)
	return en_keyword_optimizer_toast_rejected(inputs)
});